import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, Injector, inject, ChangeDetectionStrategy } from '@angular/core';
import { Utypi02Component } from './utypi02Pkg.component';
import { Utypi02DetailComponent } from './utypi02-detailPkg.component';
import { MaterialModule, PageKind } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';

@Component({
  selector: 'app-utypi02-bill',
  standalone: true,
  imports: [CommonModule,
    MaterialModule,
    JackBaseComponentModule,
    Utypi02Component,
    Utypi02DetailComponent,
  ],
  templateUrl: './utypi02BillPkg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Utypi02BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = 'utypi02'; //###
  override masterPage!: Utypi02Component;
  override detailPage!: Utypi02DetailComponent;
  constructor() {
    //const injector = inject(Injector);

    super();
    this.pageKind = PageKind.bill;
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    //this.setFormOpt2(); //###
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}
